export const INIT_COHORT_REPORTS = 'GET_COHORT_REPORTS_INIT'
export const SET_INIT_COHORT_REPORTS_STATE = "SET_INIT_COHORT_REPORTS_STATE"

/* LEGAL ENTITY DATA */
export const GET_COHORT_REPORTS_LIST = "GET_COHORT_REPORTS_LIST"
export const SET_COHORT_REPORTS_LIST = "SET_COHORT_REPORTS_LIST"
export const ADD_COHORT_REPORTS = "ADD_COHORT_REPORTS"

/* LEGAL ENTITY ACTIONS */
export const DELETE_COHORT_REPORTS = "DELETE_COHORT_REPORTS";

/* LEGAL ENTITY DATA PROFILE */
export const GET_COHORT_REPORTS_PROFILE = "GET_COHORT_REPORTS_PROFILE"
export const SET_COHORT_REPORTS_PROFILE = "SET_COHORT_REPORTS_PROFILE"
export const UPDATE_COHORT_REPORTS_PROFILE = "UPDATE_COHORT_REPORTS_PROFILE"
export const SET_ERROR_COHORT_REPORTS_PROFILE = "SET_ERROR_COHORT_REPORTS_PROFILE"

/* LOADER */
export const SHOW_COHORT_REPORTS_LIST_LOADER = "SHOW_COHORT_REPORTS_LIST_LOADER"
export const HIDE_COHORT_REPORTS_LIST_LOADER = "HIDE_COHORT_REPORTS_LIST_LOADER"

/* OPTIONS */
export const SET_COHORT_REPORTS_OPTIONS = "SET_COHORT_REPORTS_OPTIONS"
export const GET_COHORT_REPORTS_OPTIONS = "GET_COHORT_REPORTS_OPTIONS"
export const SET_COHORT_REPORTS_SHOW_FILTER = "SET_COHORT_REPORTS_SHOW_FILTER"
export const SHOW_COHORT_REPORTS_OPTIONS_LOADER = "SHOW_COHORT_REPORTS_OPTIONS_LOADER"
export const HIDE_COHORT_REPORTS_OPTIONS_LOADER = "HIDE_COHORT_REPORTS_OPTIONS_LOADER"

/* PARAMS FOR FRAGMENTATION */
export const SET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION = "SET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION"
export const GET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION = "GET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION"
export const SHOW_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER = "SHOW_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER"
export const HIDE_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER = "HIDE_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER"

/* COHORT SETUP */
export const SET_COHORT_REPORTS_COHORT_SETUP = "SET_COHORT_REPORTS_COHORT_SETUP"
export const PATCH_COHORT_REPORTS_COHORT_SETUP = "PATCH_COHORT_REPORTS_COHORT_SETUP"

export const DOWNLOAD_COHORT_REPORTS_DATA = "DOWNLOAD_COHORT_REPORTS_DATA"

// Templates
export const GET_COHORT_REPORTS_TEMPLATES = "GET_COHORT_REPORTS_TEMPLATES"
export const CHANGE_COHORT_REPORTS_TEMPLATE = "CHANGE_COHORT_REPORTS_TEMPLATE"
export const SAVE_COHORT_REPORTS_TEMPLATE = "SAVE_COHORT_REPORTS_TEMPLATE"
export const CREATE_COHORT_REPORTS_TEMPLATE = "CREATE_COHORT_REPORTS_TEMPLATE"
export const DELETE_COHORT_REPORTS_TEMPLATE = "DELETE_COHORT_REPORTS_TEMPLATE"
export const SET_COHORT_REPORTS_TEMPLATES = "SET_COHORT_REPORTS_TEMPLATES"
export const SET_COHORT_REPORTS_TEMPLATE = "SET_COHORT_REPORTS_TEMPLATE"

